export default __webpack_public_path__ + "static/media/check-green.c6afa961.svg";